import { useState } from "react";
import SectionWrapper from "../ui/SectionWrapper";

import pharmacist from "assets/generated_images/pharmacist.png";
import aideveloper from "assets/generated_images/ai-programmers.png";
import webdeveloper from "assets/generated_images/web-developer.png";
import QualityAssuranceImg from "assets/generated_images/quality-asurance.png";
import DataAdministratorImg from "assets/generated_images/database-administrator.png";
import heroImg from "assets/generated_images/Home.png"
type Role = {
  id: string;
  title: string;
  description: string;
  image: string;
};

const roles: Role[] = [
  {
    id: "ai",
    title: "AI Programmers",
    description:
      "Highly skilled AI programmers specialising in automation, data processing, machine learning, and enterprise-grade systems.",
    image: aideveloper,
  },
  {
    id: "web",
    title: "Web Developers",
    description:
      "Web developers available for large and small projects with considerable knowledge and expertise in UK consumer data.",
    image: webdeveloper,
  },
  {
    id: "qa",
    title: "Quality Assurance",
    description:
      "Quality assurance specialists providing manual and automated testing to ensure accuracy, compliance, and operational reliability.",
    image: QualityAssuranceImg,
  },
  {
    id: "db",
    title: "Database Administrators",
    description:
      "Database administrators experienced in secure data storage, performance optimisation, and regulatory compliance.",
    image: DataAdministratorImg,
  },
  {
    id: "pharma",
    title: "Pharmacists",
    description:
      "Qualified pharmacists supporting pharmaceutical operations and regulatory-driven workflows.",
    image: pharmacist,
  },
];

const HomeService: React.FC = () => {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <SectionWrapper>
      {/* HERO */}
      <div className="rounded-b-lg bg-[#F2F4F6] overflow-hidden">

        {/* MOBILE → COLUMN | DESKTOP → ROW */}
        <div className="flex flex-col lg:flex-row">

          {/* IMAGE (TOP ON MOBILE, RIGHT ON DESKTOP) */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full h-[220px] sm:h-[280px] lg:w-[300px] lg:h-[500px] overflow-hidden flex items-center justify-center">
                <img
                    src={heroImg}
                    alt="Web Development"
                    className="
                         w-full h-full object-cover object-center

                         lg:w-auto lg:h-full lg:max-w-none
                         lg:translate-x--24
                         lg:scale-[90%] lg:translate-y-[-24]
                    "
                    />
                </div>
            </div>


          {/* CONTENT */}
          <section className="flex-1 px-6 space-y-10 order-2 lg:order-1">
            <h1 className="mt-5 sm:mt-0 text-lg text-center md:text-left font-bold text-[#0B1F3A] pt-4">
              BPO specialist solutions provider.
            </h1>

            {/* Clickable Personnel List */}
            <ul className="space-y-4">
              {roles.map((role) => {
                const isOpen = openId === role.id;

                return (
                  <li
                    key={role.id}
                    className="rounded-lg border border-[#E5E7EB] bg-white"
                  >
                    {/* Header */}
                    <button
                      onClick={() => setOpenId(isOpen ? null : role.id)}
                      className="flex w-full items-center justify-between px-5 py-4 text-left font-medium text-[#0B1F3A]"
                    >
                      {role.title}
                      <span className="text-[#4F78A6]">
                        {isOpen ? "−" : "+"}
                      </span>
                    </button>

                    {/* Expanded Content */}
                    {isOpen && (
                      <div className="border-t border-[#E5E7EB] bg-[#F9FAFB] px-5 py-6">
                        <div className="grid gap-6 md:grid-cols-3 items-start">
                          {/* Image */}
                          <div className="md:col-span-1">
                            <img
                              src={role.image}
                              alt={role.title}
                              width={320}
                              height={160}
                              decoding="async"
                              className="h-40 w-full rounded-md object-cover"
                            />
                          </div>

                          {/* Text */}
                          <div className="md:col-span-2 text-[#4B5563]">
                            <p>{role.description}</p>

                            <button className="mt-4 rounded-md bg-[#0B1F3A] px-5 py-2 text-sm text-white hover:bg-[#09182E]">
                              Enquire about this service
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>

            {/* Supporting Content */}
            <p className="text-[#4B5563] pt-6">
              Our BPO clients cover{" "}
              <strong className="text-[#0B1F3A]">
                Identity Verification (IDV)
              </strong>
              ,{" "}
              <strong className="text-[#0B1F3A]">
                Know Your Customer (KYC)
              </strong>{" "}
              and{" "}
              <strong className="text-[#0B1F3A]">
                Pharmaceutical sector
              </strong>.
            </p>

            <p className="text-[#4B5563]">
              A team of Web Developers with extensive knowledge of all main
              applications including .Net, Java, MS SQL.
            </p>

            {/* Product Highlight */}
            <div className="pb-4">
              <h2 className="text-2xl text-[#0B1F3A]">
                Address Finder
              </h2>
              <p className="mt-3 text-[#4B5563]">
                Our highly cost effective UK postal look-up software and API
                that provides more than just addresses. Includes allocation of
                UPRN, precise geo-coordinates, property price and other address
                specific items.
              </p>
            </div>
          </section>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default HomeService;
